var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col" }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c("card-header", {
            attrs: { title: _vm.$router.currentRoute.meta.title }
          }),
          _c(
            "form",
            {
              attrs: { role: "form" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.update($event)
                }
              }
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-6" }, [
                    _vm.serverError
                      ? _c("div", { staticClass: "alert alert-danger" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.$t("labels.error")) + " : ")
                          ]),
                          _vm._v(" " + _vm._s(_vm.serverError) + " ")
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm.isItemFound()
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("input-text", {
                          attrs: {
                            options: {
                              id: "iban_name",
                              transPrefix: _vm.transPrefix + ".fields",
                              label: "iban_name",
                              error: _vm.fieldErrors.name
                            }
                          },
                          model: {
                            value: _vm.iban_name,
                            callback: function($$v) {
                              _vm.iban_name = $$v
                            },
                            expression: "iban_name"
                          }
                        }),
                        _c("input-text", {
                          attrs: {
                            options: {
                              id: "iban_number",
                              transPrefix: _vm.transPrefix + ".fields",
                              label: "iban_number",
                              error: _vm.fieldErrors.iban
                            }
                          },
                          model: {
                            value: _vm.iban_number,
                            callback: function($$v) {
                              _vm.iban_number = $$v
                            },
                            expression: "iban_number"
                          }
                        }),
                        _c("select-banks", {
                          attrs: {
                            options: {
                              id: "iban_bank_id",
                              transPrefix: _vm.transPrefix + ".fields",
                              label: "iban_bank",
                              error: _vm.fieldErrors.bankId
                            }
                          },
                          model: {
                            value: _vm.iban_bank_id,
                            callback: function($$v) {
                              _vm.iban_bank_id = $$v
                            },
                            expression: "iban_bank_id"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _c("div", { staticClass: "card-footer" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col text-right" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-neutral btn-sm",
                          attrs: {
                            to: { name: _vm.ibansRoutePrefix + ".show" }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-arrow-left" })]
                      ),
                      _vm.isItemFound()
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              attrs: { type: "submit", disabled: _vm.loading }
                            },
                            [
                              _vm.loading
                                ? _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-sm"
                                  })
                                : _vm._e(),
                              _c("i", { staticClass: "fa fa-save" })
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }